import { HeaderAddIcon } from '@/assets/icons/icons';
import { Flex } from 'antd';
import React from 'react';
import styles from './AddButton.module.scss';

interface AddButtonProps {
  text?: string;
  onClick?: () => void;
  addButtonWidth?: number | string;
  fontSize?: string;
  fontWeight?: string;
  background?: string;
  padding?: string;
}

const AddButton: React.FC<AddButtonProps> = ({
  text = 'Add',
  onClick,
  addButtonWidth = 60,
  fontSize = '12px',
  fontWeight = '600',
  background = '#EEEEEE',
  padding = '0 8px',
}) => {
  return (
    <Flex
      onClick={onClick}
      align='center'
      justify='center'
      gap='4px'
      className='add-button-pill'
      style={{
        cursor: 'pointer',
        fontSize,
        fontWeight,
        background,
        borderRadius: '999px',
        width: 'auto',
        minHeight: '28px',
        height: 'auto',
        userSelect: 'none',
        minWidth: addButtonWidth,
        padding,
      }}
    >
      <HeaderAddIcon />
      <span className={styles.label}>{text}</span>
    </Flex>
  );
};

export default AddButton;
